import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import MoreLink from './MoreLink';
import { longDate, publishedDate } from './meetDates';

const Card = ({ item, isEditMode, showDescription }) => {
  const date = publishedDate(item);
  return (
    <article className="asaj-news-card">
      <div className={`asaj-news-img${item.image_field ? '' : ' is-empty'}`}>
        {item.image_field && (
          <Component componentName="PreviewImage" item={item} alt="" />
        )}
      </div>
      {date && (
        <time className="asaj-cat" dateTime={date}>
          {longDate(date)}
        </time>
      )}
      <h3>
        <ConditionalLink item={item} condition={!isEditMode}>
          {item.title}
        </ConditionalLink>
      </h3>
      {showDescription && item.description && <p>{item.description}</p>}
    </article>
  );
};

// Latest news: a lead story, a second story, and a column of up to four more
const FeatureGridTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  const [first, second, ...rest] = items;
  const side = rest.slice(0, 4);
  return (
    <>
      <div className="asaj-news">
        {first && <Card item={first} isEditMode={isEditMode} showDescription />}
        {second && <Card item={second} isEditMode={isEditMode} />}
        {side.length > 0 && (
          <div className="asaj-news-side">
            {side.map((item) => (
              <Card key={item['@id']} item={item} isEditMode={isEditMode} />
            ))}
          </div>
        )}
      </div>
      <MoreLink
        linkTitle={linkTitle}
        linkHref={linkHref}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default FeatureGridTemplate;
